import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
import { imageCircleStyling } from './styling';
export function ImageCircle({ image, size, outline }) {
    return (_jsx("div", { className: cn(imageCircleStyling({ size, outline })), children: _jsx("img", { src: image, alt: "Person", className: "w-full h-full object-cover rounded-pill" }) }));
}
